import { BannerSalePage } from 'components/main-page/sale-page/banner-sale-page/BannerSalePage'

export const BannerSalePageContainer = ({ salePageDetail, errorForm, onChangeForm }) => {
    const copyItems = [...(salePageDetail?.banners || [])]

    const setItems = (items) => {
        onChangeForm({ banners: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                mobile_image_url: null,
                desktop_image_url: null,
            },
        ])
    }

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        errorForm,
    }

    return <BannerSalePage {...props} />
}
